import React, {useRef} from "react"
import Card, {CardClickAction} from "../Card/card"
import Text from "../Text/text"
import {MutiCard} from "../Card/muticard/muticard"
import Style from "./answer.less"
import {Evaluation, EvaluationData} from "../Evaluation/evaluation"

export interface AnswerProps {
    data?: AnswerData
    onCardClick: (action: CardClickAction) => void
    onMouseEnter: () => void
    onMouseLeave: () => void
    isFullScreen?: boolean
    onEvaluated: (data: EvaluationData) => void // TODO 和后端确定格式后去掉any
}

export interface AnswerData {
    type: "input" | "answer"
    content: AnswerDataContent
}

export interface AnswerDataContent {
    cardListJson?: Array<string>
    title?: string
    id?: number
    intent?: string
}

export type CardData = Object

const FaqIntentType = "INTERNAL_FAQ"

const Answer: React.FC<AnswerProps> = (props) => {
    const cardJsonList = props.data?.content?.cardListJson

    let cardDataList: Array<CardData> = []
    if (cardJsonList != null && cardJsonList.length !== 0) {
        cardDataList = cardJsonList.map((item) => JSON.parse(item))
    }

    /**
     * 关于评价放到哪个地方，有三种情况
     * 1. 只有一段引导语，这里不放评价
     * 2. 只有一段文本，没有卡片，评价放到这里
     * 3. 只要有卡片，可以认为卡片一定在最后，评价放到这里
     * 所以根据是否有卡片来判断即可
     */
    const hasCard = cardDataList.length > 0

    const showEvaluation = props.data?.content.intent === FaqIntentType

    //  若回答是文本，且长度太短，两个点赞按钮应该左右排布
    function isVerticalLayout(isFullScreen: boolean | undefined, source: string) {
        if (isFullScreen === true) {
            // 100刚好是全角字符3行中文字符
            return source.length > 100
        } else {
            return source.length > 15
        }
    }

    const getText = () => {
        let source = props.data?.content?.title
        if (source == null) {
            return null
        }
        if (source.indexOf("\n") === -1) {
            const verticalLayout = isVerticalLayout(props.isFullScreen, source)
            return (
                <div className={Style["evaluation-wrapper"]}>
                    <Text
                        onMouseEnter={props.onMouseEnter}
                        onMouseLeave={props.onMouseLeave}
                        type={"answer"}
                        isFullScreen={props.isFullScreen}
                        content={source}
                    />
                    {showEvaluation && (hasCard ? null : <Evaluation onEvaluation={props.onEvaluated} isVerticalLayout={verticalLayout}/>)}
                </div>
            )
        }
        const list = source.split("\n")
        return (
            <Text
                onMouseEnter={props.onMouseEnter}
                onMouseLeave={props.onMouseLeave}
                type={"answer"}
                isFullScreen={props.isFullScreen}
                content={
                    <ul>
                        {list.map((item) => (
                            <li key={item}>{item}</li>
                        ))}
                    </ul>
                }
            />
        )
    }

    const getCard = () => {
        if (cardDataList.length === 0) {
            return null
        }

        return (
            <div className={Style["evaluation-wrapper"]}>
                <MutiCard
                    onMouseEnter={props.onMouseEnter}
                    onMouseLeave={props.onMouseLeave}
                    list={cardDataList.map((cardData, index) => (
                        <Card key={index} onCardClick={props.onCardClick} data={cardData}/>
                    ))}
                />
                {showEvaluation ? <Evaluation onEvaluation={props.onEvaluated}/> : null}
            </div>
        )
    }

    const sectionRef = useRef<HTMLDivElement>(null)

    return (
        <section ref={sectionRef} className={Style["answer-section"]}>
            {getText()}
            {getCard()}
        </section>
    )
}

export default Answer
